import React, { useRef, useState } from 'react';
import { Button } from 'primereact/button';
import { Menu } from 'primereact/menu';
import { Toast } from 'primereact/toast';
import { API_DELETE_CHAT, API_CLEAR_CHAT,API_BLOCK_CHAT } from '../../../../api/chat.service';
import axiosInstance from '../../../../api/axios.instance';
import CustomDialog from '../../../../components/CustomDialog';
import { Text } from '../../../../components/Text';
import { CustomButton } from '../../../../components/CustomButton';
import { resetChatUser } from '../../../../reducers/enqChatSlice';
import {actionAlertMessage,initialActionState,menuOption} from "./chat-control-constants"
import { useDispatch } from 'react-redux';
import { deleteChat, clearChat, blockUnblockChat } from '../../../../reducers/enqChatSlice';
const ChatControlMenu = (props) => {
    const { chatInfo } = props;
    const [actionState,setActionState] = useState(initialActionState)
      const [showAlert,setAlert] = useState(false);
      const dispatch = useDispatch()

    const menuRef = useRef(null);
    const toast = useRef(null);

    const handleClearChat = () => {
        dispatch(clearChat(chatInfo.phone))
        .then(res=>{
            setAlert(false)
        }).catch(err=>{
            console.log('err',err)
        })
    }

    const handleBlockChat = () => {
       
            const payload = {
                customerMobile: chatInfo.phone,
                blockStatus: "block",
              }
              dispatch(blockUnblockChat(payload))
              .then(res=>{
                setAlert(false)
              })
              .catch(err=>err)
       

    }
    const handleUnBlockChat = () => {
            const payload = {
                customerMobile: chatInfo.phone,
                blockStatus: "unblock",
              }
              dispatch(blockUnblockChat(payload))
              .then(res=>{
                setAlert(false)
              })
              .catch(err=>err)
    }

    const handleDeleteChat = () => {
        dispatch(deleteChat(chatInfo.phone))
        .then(res=>{
            setAlert(false)
        })
        .catch(error=>{
            console.error(error)
        })
    }
    const updateAaction  = (e) =>{
        const value = e.item.value;
        setActionState({...initialActionState, actionName:value,alertMessage:actionAlertMessage[value]})
        setAlert(true);
    }
    const blockItem= {
        label: 'Block',
        value:menuOption.BLOCK,
        command:updateAaction,
    };
  
    const items = [
       
        {
            label: 'Clear chat',
            value:menuOption.CLEAR,
            command:updateAaction,
        },
        {
            label: 'Delete chat',
            value:menuOption.DELETE,
            command:updateAaction,
        }
    ];

    const cancelAction = ()=>{
        setAlert(false);
        setActionState(initialActionState)
    }

    const executeAction = ()=>{
        switch(actionState.actionName){
            case menuOption.CLEAR :
                handleClearChat();
            break;
            case menuOption.DELETE :
                handleDeleteChat();
            break;
            case menuOption.BLOCK :
                handleBlockChat();
            break;
            case menuOption.UNBLOCK :
                handleUnBlockChat()
            break;
            default:
                return;
        }
    }
const isUserBlocked = chatInfo?.isOptOut;
if(!isUserBlocked){
    items.unshift(blockItem);
}

return <div className="card flex justify-content-center">
        <Toast ref={toast}></Toast>
        {
        showAlert && <CustomDialog visible={showAlert} header={<Text>Alert</Text>} onHide={cancelAction} >
        <Text >
          {actionState.alertMessage}
        </Text>
        <div className='flex justify-content-end gap-3 align-items-center mt-3'>
          <CustomButton varient="text" label={"Cancel"} onClick={cancelAction} />
          <CustomButton varient="filled" label={<span className='capitalize'>{actionState.actionName}</span>} onClick={executeAction} />

        </div>
        </CustomDialog>
      }
        <Menu model={items} popup ref={menuRef} id="popup_menu_left" />
        <Button icon="pi pi pi-ellipsis-v" rounded text className="h-auto" onClick={(event) => menuRef.current.toggle(event)} aria-controls="popup_menu_left" aria-haspopup />
    </div>
}

export default ChatControlMenu;